<template>
  <transition name="opacity" appear>
    <div class="loading-area" :class="theme">
      <div class="loading-area-icon">
        <div class="loading-area-default-icon" v-if="!hasIcon">
          <svg-loader src="/assets/images/hotmart-logotype.svg"></svg-loader>
        </div>

        <slot name="icon"></slot>
      </div>

      <div class="loading-area-content" v-if="$slots.default">
        <slot></slot>
      </div>
    </div>
  </transition>
</template>

<style lang="scss" scoped>
  @import '~stylesheets/meta';

  .loading-area {
    @include opacity-transition;
    display: flex;
    justify-content: center;
    align-items: center;
    flex-direction: column;
    position: absolute;
    top: 0;
    right: 0;
    bottom: 0;
    left: 0;
    background: #fff;
    z-index: 80;
    overflow: hidden;

    &.dark {
      background: rgba($color-marine, .9);

      .loading-area-content {
        color: #fff;
      }
    }

    &.simple {
      .loading-area-icon {
        width: 80%;
        height: 80%;
      }

      .loading-area-default-icon {
        .svg-image {
          display: none;
        }

        &:after {
          width: 70%;
          height: 70%;
        }
      }
    }

    &.relative {
      position: relative;
    }
  }

  .loading-area-icon {
    position: relative;
    width: 50px;
    height: 50px;
  }

  .loading-area-default-icon {
    position: absolute;
    width: 100%;
    height: 100%;

    &:before,
    &:after {
      width: 100%;
      height: 100%;
      display: block;
      position: absolute;
      top: 0;
      right: 0;
      left: 0;
      bottom: 0;
      margin: auto;
      z-index: 30;
      border: 1px solid transparent;
      border-top-color: #DCE0E3;
      border-left-color: #DCE0E3;
      border-radius: 100%;
      transform: rotate(0deg) translateZ(0);
      animation: spin .5s linear infinite;
      content: '';
    }

    &:after {
      width: 40px;
      height: 40px;
      border-top-color: #A9B1BA;
      border-left-color: #A9B1BA;
      transform: rotate(0deg) translateZ(0);
      animation: spinrevert 750ms linear 0s infinite;
    }

    .svg-image {
      height: 100%;
      width: 100%;
      position: relative;
    }

    svg {
      margin: auto;
      height: 24px;
      position: absolute;
      top: 0;
      right: 0;
      bottom: 0;
      left: 0;

      path {
        fill: #A9B1BA;
      }
    }
  }

  .loading-area-content {
    font-size: 14px;
    font-weight: 700;
    color: rgba($color-gray, .7);
    text-align: center;

    ::v-deep p {
      margin: .5em;
    }
  }

  @keyframes spin {
    to {
      transform: rotate(360deg) translateZ(0);
    }
  }

  @keyframes spinrevert {
    to {
      transform: rotate(-360deg) translateZ(0);
    }
  }
</style>

<script>
  export default {
    name: 'loading-area',
    props: {
      theme: String
    },
    computed: {
      hasIcon () {
        return !!this.$slots['icon']
      }
    }
  }
</script>
